export class Errored {
	static readonly type = '[titleplus] errored';
	constructor(public logData: unknown) {}
}

export class Loaded {
	static readonly type = '[titleplus] loaded';
	constructor(public connectedIds: string[]) {}
}

export class Loading {
	static readonly type = '[titleplus] loading';
}

export class Revoke {
	static readonly type = '[titleplus] revoke';
	constructor(public userId: string) {}
}
